import { Box, Paper, Typography, Stack } from "@mui/material";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import CompanySetupPage, { SETUP_TABS } from "./CompanySetupPage.tsx";
import { useSnackBar } from "../FlowBuilder/Common/SnackBar/index.tsx";
import { useNavigate, useParams } from "react-router";

export default function CompanySetup() {
    const { showSnackBar } = useSnackBar();
    const navigate = useNavigate();
    const { tab } = useParams<{ tab?: string }>();

    const activeStep = tab && SETUP_TABS.includes(tab as any) ? SETUP_TABS.indexOf(tab as any) : 0;

    const handleStepChange = (newStep: number) => {
        const tabKey = SETUP_TABS[newStep] ?? SETUP_TABS[0];
        navigate(`/r/machadalostudio/companysetup/${tabKey}`, { replace: false });
    };

    const handleSkipSetup = () => {
        showSnackBar(
            "You can complete company setup later from the settings menu.",
            "info"
        );
        navigate("/r/machadalostudio/ai");
    };

    return (
        <Box sx={{ minHeight: "100vh", bgcolor: "#f6f8fc", p: { xs: 2, md: 1 } }}>
            <Paper
                elevation={0}
                sx={{
                    borderRadius: 4,
                    overflow: "hidden",
                    border: "1px solid",
                    borderColor: "divider",
                    boxShadow: "0 12px 40px rgba(15,23,42,0.08)",
                }}
            >
                <Box sx={{ px: { xs: 3, md: 5 }, py: 1,  bgcolor: 'primary.main', color: "white" }}>
                    <Stack direction={{ xs: "column", md: "row" }} justifyContent="space-between" alignItems={{ xs: "flex-start", md: "center" }} spacing={3}>
                        <Stack direction="row" spacing={2} alignItems="center">
                            <Box sx={{ width: 58, height: 58, borderRadius: 3, bgcolor: "rgba(255,255,255,0.15)", backdropFilter: "blur(10px)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                <AutoAwesomeIcon sx={{ fontSize: 30 }} />
                            </Box>
                            <Box>
                                <Typography variant="h4" fontWeight={700}>Company Setup</Typography>
                                <Typography sx={{ mt: .5, opacity: .9 }}>
                                    Configure your organization profile, branding and business information.
                                </Typography>
                            </Box>
                        </Stack>
                    </Stack>
                </Box>

                <Box sx={{ px: { xs: 2, md: 5 }, py: 4, bgcolor: "#fafbfd" }}>
                    <Paper elevation={0} sx={{ borderRadius: 3, border: "1px solid", borderColor: "divider", p: { xs: 2, md: 4 }, bgcolor: "#fff" }}>
                        <CompanySetupPage
                            onSkip={handleSkipSetup}
                            onComplete={handleSkipSetup}
                            activeStep={activeStep}
                            onStepChange={handleStepChange}
                        />
                    </Paper>
                </Box>
            </Paper>
        </Box>
    );
}